module.exports = __webpack_public_path__ + "assets/images/2hLD63AB.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wopi360-logo.svg
// module id = 1139
// module chunks = 0